<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>

        <div class="col-md-12">
          <label for="" style="width: 100%"
            >{{ $t("module.level")
            }}<span style="float: right">{{
              $t("module.grupokuma.level", { level })
            }}</span></label
          >
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="5"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.grupokuma.marquee")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="direction"
            :active-text="$t('module.yes')"
            :active-value="'satir'"
            :inactive-value="'tumu'"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div>
        <div
          v-for="(row, rowIndex) in stack"
          style="display: inline-block; width: 100%; text-align: left"
          v-if="(rowIndex == currentRow || direction == 'tumu') && end == false"
        >
          <div
            :class="[
              direction == 'satir' &&
              wordIndex > currentWord &&
              wordIndex % level != 0
                ? 'merge-word'
                : direction == 'tumu' &&
                  ((wordIndex > currentWord && rowIndex == currentRow) ||
                    rowIndex > currentRow) &&
                  wordIndex % level != 0
                ? 'merge-word'
                : '',
              direction == 'satir' && wordIndex > currentWord
                ? 'highlight2'
                : direction == 'tumu' &&
                  ((wordIndex > currentWord && rowIndex == currentRow) ||
                    rowIndex > currentRow)
                ? 'highlight2'
                : '',
            ]"
            class="dark-inverted"
            v-for="(word, wordIndex) in row"
            style="
              font-size: 18px;
              cursor: pointer;
              display: inline-block;
              text-align: center;
              padding: 0px 1px;
              margin-right: 2px;
              position: relative;
              border-radius: 0 !important;
              line-height: 27px;
              margin-bottom: 3px;
              font-family: Roboto;
            "
          >
            <span
              style="position: relative"
              :style="{
                opacity:
                  direction == 'satir' && wordIndex > currentWord
                    ? 0
                    : direction == 'tumu' &&
                      ((wordIndex > currentWord && rowIndex == currentRow) ||
                        rowIndex > currentRow)
                    ? 0
                    : 1,
              }"
              >{{ word.word }}</span
            >
          </div>
        </div>
      </div>
      <div v-if="end == true">{{ $t("module.finished") }}</div>
    </div>
    <div
      :style="{ width: wrapper.width + 'px' }"
      style="margin: 0 auto; border-radius: 0px"
    >
      <div
        class="progress"
        style="border-radius: 0px; height: 4px"
        v-if="stack.length"
      >
        <div
          class="progress-bar"
          style="border-radius: 0px"
          :style="{
            width: (currentRow / (stack.length - 1)) * 100 + '%',
            height: '40px',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: ["config"],
  name: "GrupOkuma",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      level: 1,
      currentLetter: null,
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      startDate: new Date().getTime(),
      endDate: null,
      skip: 0,
      end: false,
      currentStack: 0,
      skip: 0,
      words: [],
      stack: [],
      currentWordCounter: 0,
      settings: false,
      blocks: [],
      currentRow: 0,
      currentWord: 0,
      direction: "satir",
      autoLevel: 0,
      mode: 1,
      modes: {
        1: "Silinerek Gölgeleme",
        2: "Silinmeden Gölgeleme",
        3: "Okunan Gölgeleme",
        4: "Yazarak Gölgeleme",
      },
      wordCount: 0,
      levelMap: {
        İlkokul: {
          path: "ilkokul",
          max: 26,
        },
        Ortaokul: {
          path: "ortaokul",
          max: 26,
        },
        Lise: {
          path: "lise",
          max: 26,
        },
        Yetişkin: {
          path: "yetiskin",
          max: 26,
        },
        LGS: {
          path: "lgs",
          max: 13,
        },
        YKS: {
          path: "yks",
          max: 26,
        },
        "Tüm Sınavlara Hazırlık": {
          path: "sinav",
          max: 26,
        },
      },
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  created() {
    if (this.$store.state.user.grade == "LGS") this.direction = "tumu";

    var levelMap = this.levelMap[this.$store.state.user.level];

    if (this.$i18n.locale != "az") {
      for (let index = 1; index <= levelMap.max; index++) {
        var m = require("../../assets/goz-ritim/" +
          levelMap.path +
          "/" +
          index +
          ".js").default;

        this.words.push(
          m.text
            .replace(/\s\s+/g, " ")
            .replace(/[\n\r]/g, "")
            .trim()
            .split(" ")
            .filter((k) => k.trim() != "")
            .join(" ")
        );
      }
    } else {
      for (let index = 1; index < 11; index++) {
        var m = require("../../assets/goz-ritim/az/" + index + ".js").default;

        this.words.push(
          m.text
            .replace(/\s\s+/g, " ")
            .replace(/[\n\r]/g, "")
            .trim()
            .split(" ")
            .filter((k) => k.trim() != "")
            .join(" ")
        );
      }
    }
  },
  methods: {
    getTextWidth(text, font = this.getCanvasFontSize()) {
      const canvas =
        this.getTextWidth.canvas ||
        (this.getTextWidth.canvas = document.createElement("canvas"));
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return metrics.width;
    },
    getCssStyle(element, prop) {
      return window.getComputedStyle(element, null).getPropertyValue(prop);
    },
    getCanvasFontSize(el = document.body) {
      const fontWeight = this.getCssStyle(el, "font-weight") || "normal";
      const fontSize = this.getCssStyle(el, "font-size") || "16px";
      const fontFamily =
        this.getCssStyle(el, "font-family") || "Times New Roman";

      return `${fontWeight} ${fontSize} ${fontFamily}`;
    },
    getOpacity(wordIndex, rowIndex) {
      if (this.direction == "satir") {
        if (this.mode == 1) {
          if (wordIndex < this.currentWord) {
            return 0;
          } else {
            return 1;
          }
        }

        if (this.mode == 2) {
          return 1;
        }

        if (this.mode == 3) {
          if (
            wordIndex < this.currentWord ||
            wordIndex > this.currentWord + this.level - 1
          ) {
            return 0;
          } else {
            return 1;
          }
        }

        if (this.mode == 4) {
          if (wordIndex > this.currentWord + this.level - 1) {
            return 0;
          } else {
            return 1;
          }
        }
      } else {
        if (this.mode == 1) {
          if (wordIndex < this.currentWord && rowIndex <= this.currentRow) {
            return 0;
          } else {
            return 1;
          }
        }

        if (this.mode == 2) {
          return 1;
        }

        if (this.mode == 3) {
          if (
            wordIndex < this.currentWord ||
            wordIndex > this.currentWord + this.level - 1 ||
            rowIndex < this.currentRow ||
            rowIndex > this.currentRow
          ) {
            return 0;
          } else {
            return 1;
          }
        }

        if (this.mode == 4) {
          if (
            wordIndex > this.currentWord + this.level - 1 ||
            rowIndex > this.currentRow
          ) {
            return 0;
          } else {
            return 1;
          }
        }
      }
      return 1;
    },
    start() {
      this.stack = [];
      this.currentRow = 0;
      this.currentWord = 0;
      var metin = this.words[_.random(0, this.words.length - 1)];
      var words = metin
        .split(" ")
        .map((k) => k.trim())
        .filter((k) => k != "");
      var width = 0;
      this.wordCount = words.length;

      var row = 0;
      var wordCount = 0;
      var charCount = 0;
      this.stack.push([]);

      words.map((word, index) => {
        if (
          this.getTextWidth(word, "bold 13px arial") + width >
          500 - wordCount * 2
        ) {
          row += 1;
          wordCount = 0;
          width = 0;
          this.stack.push([]);
        }

        if (row == 16) return;

        this.stack[row].push({
          word,
          highlight: false,
        });
        width += this.getTextWidth(word, "bold 13px arial");
        wordCount += 1;
      });

      this.start2();
    },
    start2() {
      this.interval = setInterval(() => {
        if (this.pause) return;
        if (this.currentWord >= this.stack[this.currentRow].length - 1) {
          if (this.currentRow == this.stack.length - 1) {
            clearInterval(this.interval);
            this.start();
            return;
          } else {
            this.currentRow += 1;
          }
          this.currentWord = this.level - 1;
        } else {
          this.currentWord += this.level;
        }
        this.currentWordCounter += this.level;
      }, this.speeds[this.speed - 1]);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start2();
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px;
}

.merge-word::after {
  content: " ";
  position: absolute;
  right: -2px;
  height: 100%;
  width: 10px;
  background-color: #b7b7b7;
}

.highlight2 {
  background-color: #b7b7b7;
}

.merge-word::after {
  content: " ";
  position: absolute;
  right: -2px;
  height: 100%;
  width: 10px;
  background-color: #b7b7b7;
}

.is-dark {
  .highlight2 {
    background-color: #b7b7b7;
  }

  .merge-word::after {
    content: " ";
    position: absolute;
    right: -2px;
    height: 100%;
    width: 10px;
    background-color: #b7b7b7;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/GrupOkuma.vue